module.exports = __webpack_public_path__ + "img/paypal.a4bfca1a.png";